/* 컬러 이모지 글리프는 `color`의 RGB는 무시하지만 알파는 그대로 곱해 렌더링된다.
 * 마크다운 본문(text-sea-ink-soft, 알파 0.88) 안의 이모지가 같이 흐려지므로,
 * 텍스트를 이모지/비이모지 조각으로 분리해 렌더러(markdown-lexical)가 이모지
 * 조각에만 알파를 1로 복원하는 인라인 스타일을 입힌다. */

// 이모지-표시 시퀀스만 매치: 국기(RI쌍) | 키캡 | (기본 이모지 | 픽토그래프+VS16) + 연속부.
// ©·™·↗ 같은 텍스트-표시 기본 문자(Extended_Pictographic이지만 VS16 없음)는 의도적으로 제외.
// VS16(U+FE0F)·ZWJ(U+200D)·키캡(U+20E3)은 비가시 문자라 \uXXXX 이스케이프로만 표기한다.
const EMOJI_SEQUENCE = new RegExp(
	[
		"(?:\\p{Regional_Indicator}{2}", // 국기 (Regional Indicator 쌍)
		"|[#*0-9]\\uFE0F?\\u20E3", // 키캡 (숫자 + VS16 + U+20E3)
		"|(?:\\p{Emoji_Presentation}|\\p{Extended_Pictographic}\\uFE0F)", // 기본 이모지 | 픽토그래프+VS16
		"(?:\\uFE0F|\\p{Emoji_Modifier}|\\u200D\\p{Extended_Pictographic}\\uFE0F?\\p{Emoji_Modifier}?)*)", // 스킨톤·ZWJ 연속부
	].join(""),
	"gu",
);

export type EmojiSegment = { text: string; emoji: boolean };

/** 이모지가 없으면 null (분리 불필요 신호), 있으면 순서 보존 조각 목록. */
export function splitEmojiSegments(value: string): EmojiSegment[] | null {
	const matches = [...value.matchAll(EMOJI_SEQUENCE)];
	if (matches.length === 0) {
		return null;
	}
	const out: EmojiSegment[] = [];
	let last = 0;
	for (const match of matches) {
		const index = match.index ?? 0;
		if (index > last) {
			out.push({ text: value.slice(last, index), emoji: false });
		}
		out.push({ text: match[0], emoji: true });
		last = index + match[0].length;
	}
	if (last < value.length) {
		out.push({ text: value.slice(last), emoji: false });
	}
	return out;
}
